import axios from 'axios';

const getApiBaseUrl = () => {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  return '/api';
};

const API_BASE_URL = getApiBaseUrl();

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

export interface ProjectByYear {
  year: string;
  count: number;
}

export interface UserWorkHours {
  userName: string;
  hours: number;
}

export interface ProjectTimeDistribution {
  projectName: string;
  munkaTargya: string;
  hours: number;
}

export interface DashboardStats {
  activeProjects: number;
  totalMonthlyHours: number;
  currentUserMonthlyHours: number;
  projectsByYear: ProjectByYear[];
  currentUserProjectDistribution: ProjectTimeDistribution[];
}

export const dashboardService = {
  async getDashboardStats(): Promise<DashboardStats> {
    try {
      const response = await api.get<DashboardStats>('/Dashboard/stats');
      return response.data;
    } catch (error) {
      console.error('Error fetching dashboard stats:', error);
      throw error;
    }
  }
};
